import React, { useEffect } from "react";
import TinySlider from "tiny-slider-react";
import "../../node_modules/tiny-slider/dist/tiny-slider.css";
import CardEcosistema from "./CardEcosistema";

import { useLocation } from "react-router-dom";
import ins from "../assets/images/sidom/fotos/02.png";
import sr from "../assets/images/sidom/fotos/03.png";
import pay from "../assets/images/sidom/fotos/04.png";
import msr from "../assets/images/sidom/fotos/05.png";
import misim from "../assets/images/sidom/fotos/06.png";
import img from "../assets/images/sidom/fotos/FlechaenCirc1.png";

export default function Ecosistema() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  const ecosistemaData = [
    {
      icon: sr,
      title: "SIDOM Smart Reader",
      description:
        "Centralización, validación y almacenamiento de toda la documentación de comercio exterior. Optimice los tiempos operativos. Obtenga Compliance en los procesos al convertir tareas manuales en un proceso automático.",
      buttonText: "Conoce SIDOM Smart Reader",
      link: "/sidom-smart-reader",
    },
    {
      icon: ins,
      title: "SIDOM Insurance",
      description:
        "La primera solución InsurTech de Seguros embebidos para la gestión integral de las pólizas relacionadas con la operatoria de comercio exterior. Permite cotizar y contratar seguros de manera transparente y en tiempo real.",
      buttonText: "Conoce SIDOM Insurance",
      link: "/sidom-insurance",
    },
    {
      icon: pay,
      title: "SIDOM Pay",
      description:
        "Botón de pago que agiliza los procesos administrativos y financieros de las Empresas y los Agentes Aduanales. Con el uso de tecnología RPA, reduce un 100% los tiempos de pago y los errores derivados de la carga manual de datos.",
      buttonText: "Conoce SIDOM Pay",
      link: "/sidom-pay",
    },
    {
      icon: msr,
      title: "SIDOM MRE",
      description:
        "Administra regímenes de Importaciones Temporales, RAF, Saldos y Vencimientos de Stock, Registros de Insumos, etc. Desarrollos a medida para regímenes de cada país. Automatice alertas y notificaciones que previenen multas.",
      buttonText: "Conoce SIDOM MRE",
      link: "/sidom-mre",
    },
    {
      icon: misim,
      title: "SIDOM MiSIM",
      description:
        " Plataforma para Despachantes de Aduana integrada con Sistema María. Permite resolver las principales dificultades operativas a partir de la aplicación de tecnología IA y RPA.",
      buttonText: "Conoce SIDOM Insurance",
      link: "/sidom-misim",
    },
    {
      icon: sr,
      title: "SIDOM Smart Reader",
      description:
        "Centralización, validación y almacenamiento de toda la documentación de comercio exterior. Optimice los tiempos operativos. Obtenga Compliance en los procesos al convertir tareas manuales en un proceso automático.",
      buttonText: "Conoce SIDOM Smart Reader",
      link: "/sidom-smart-reader",
    },
    {
      icon: ins,
      title: "SIDOM Insurance",
      description:
        "La primera solución InsurTech de Seguros embebidos para la gestión integral de las pólizas relacionadas con la operatoria de comercio exterior. Permite cotizar y contratar seguros de manera transparente y en tiempo real.",
      buttonText: "Conoce SIDOM Insurance",
      link: "/sidom-insurance",
    },
    {
      icon: pay,
      title: "SIDOM Pay",
      description:
        "Botón de pago que agiliza los procesos administrativos y financieros de las Empresas y los Agentes Aduanales. Con el uso de tecnología RPA, reduce un 100% los tiempos de pago y los errores derivados de la carga manual de datos.",
      buttonText: "Conoce SIDOM Pay",
      link: "/sidom-pay",
    },
    {
      icon: msr,
      title: "SIDOM MRE",
      description:
        "Administra regímenes de Importaciones Temporales, RAF, Saldos y Vencimientos de Stock, Registros de Insumos, etc. Desarrollos a medida para regímenes de cada país. Automatice alertas y notificaciones que previenen multas.",
      buttonText: "Conoce SIDOM MRE",
      link: "/sidom-mre",
    },
    {
      icon: misim,
      title: "SIDOM MiSIM",
      description:
        " Plataforma para Despachantes de Aduana integrada con Sistema María. Permite resolver las principales dificultades operativas a partir de la aplicación de tecnología IA y RPA.",
      buttonText: "Conoce SIDOM Insurance",
      link: "/sidom-misim",
    },
  ];
  const settings = {
    items: 1,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayTimeout: 8000, // 3 segundos
    autoplayButtonOutput: false,
    controlsText: [
      `<img src=${img} alt="logo" class="bg-sidom-orange -rotate-90 w-40 rounded-full"/>`,
      `<img src=${img} alt="logo" class="bg-sidom-orange w-40 rounded-full"/>`,
    ],
    nav: true,
    speed: 8000,
    gutter: 20,
    responsive: {
      0: {
        items: 1,
        gutter: 20,
      },
      768: {
        items: 2,
        gutter: 20,
      },
      1100: {
        items: 3,
        gutter: 20,
      },
  
    },
  };

  return (
    <div className="bg-gradient-to-t from-sidom-orange to-sidom-blue w-full h-full border border-sidom-orange dark:border-sidom-blue">
      <div data-aos="fade-up" data-aos-delay="800" className="container">
        <h2 className="text-4xl md:text-5xl mt-[100px] text-sidom-light font-extrabold mb-[60px] text-left">
          Ecosistema{" "}
          <span className="text-sidom-orange text-6xl font-black">SIDOM</span>
        </h2>

        <div className="bg-gradient-to-t from-transparent via-transparent to-transparent p-2 mb-[100px]">
          <TinySlider settings={settings}>
            {ecosistemaData.map((item, index) => (
              <CardEcosistema
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
                buttonText={item.buttonText}
                link={item.link}
              />
            ))}
          </TinySlider>
        </div>
      </div>
    </div>
  );
}
